import React from 'react';
import { motion } from 'framer-motion';
const tags = ['Técnica', 'Progresión', 'Planificación', 'Fuerza', 'Cardio funcional', 'Alimentación', 'Anti-abandono', 'Seguimiento', 'Sobrecarga', 'Estaciones HYROX', 'Semana perfecta', 'Resultados reales'];
const skills = ['Resistencia funcional', 'Fuerza real', 'Estaciones HYROX', 'Farmer Carry', 'Lunges con carga', 'Wall Balls', 'Empuje y tirón', 'Cardio sostenido', 'Planificación semanal', 'Progresión medible'];
export function SystemOverview() {
  return <section className="py-24 px-4 bg-brand-black" data-id="element-249">
      <div className="max-w-5xl mx-auto" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-251">
          <div className="text-brand-copper font-semibold tracking-widest uppercase text-sm mb-4" data-id="element-252">
            Idea Hub Digital
          </div>
          <h2 className="text-3xl md:text-5xl text-white leading-tight mb-6" data-id="element-253">
            EL SISTEMA NÚMERO 1 PARA MUJERES QUE QUIEREN{' '}
            <span className="text-brand-pink" data-id="element-254">HYROX EN ARGENTINA</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-255">
            Sistema completo · 3 Módulos + 3 Bonos · Desde principiante hasta tu
            primera carrera · Todo resuelto.
          </p>
        </motion.div>

        <div className="bg-brand-dark rounded-3xl p-8 md:p-12 border border-gray-800 relative overflow-hidden" data-id="element-256">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-pink/5 blur-[100px] rounded-full pointer-events-none" data-id="element-257" />

          <div className="flex flex-wrap gap-4 justify-center mb-10" data-id="element-258">
            <div className="bg-brand-black border border-brand-pink/30 text-white px-6 py-3 rounded-full font-display text-xl" data-id="element-259">
              +150 págs.
            </div>
            <div className="bg-brand-black border border-brand-pink/30 text-white px-6 py-3 rounded-full font-display text-xl" data-id="element-260">
              30+ rutinas
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-261">
            {tags.map((tag, i) => <span key={i} className="bg-gray-900 text-gray-300 px-3 py-1.5 rounded-md text-sm border border-gray-800" data-id="element-262">
                {tag}
              </span>)}
          </div>

          <div className="text-center mb-12" data-id="element-263">
            <p className="text-xl md:text-2xl text-white font-semibold" data-id="element-264">
              Funciona desde hoy en tu casa, tu gym o tu patio.
            </p>
            <p className="text-brand-pink font-display text-2xl md:text-3xl mt-4" data-id="element-265">
              Tu primera carrera HYROX en 12 semanas con el sistema correcto.
            </p>
          </div>

          <div className="border-t border-gray-800 pt-10" data-id="element-266">
            <h3 className="text-white font-bold mb-6 text-center text-lg uppercase tracking-wider" data-id="element-267">
              Habilidades incluidas:
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-id="element-268">
              {skills.map((skill, i) => <div key={i} className="flex items-center gap-2 text-sm text-gray-400" data-id="element-269">
                  <div className="w-1.5 h-1.5 rounded-full bg-brand-copper flex-shrink-0" data-id="element-270" />
                  <span data-id="element-271">{skill}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}